import styled from 'styled-components';

export const AppToolbar = styled.div`
  ${({theme}) => `
    position: relative;
    
    & .tool-bar {
        padding-left: 20px;
        padding-right: 20px;
        min-height: 56px;
        ${theme.breakpoints.up('sm')} {
            min-height: 70px;
         }
        ${theme.breakpoints.up('md')} {
            padding-left: 30px;
            padding-right: 30px;
          }
    }
    
    & .grow {
      flex-grow: 1;
    }
    
    & .menu-button {
      margin-right: ${theme.spacing(2)}px;
    }
    
    & .menu-icon {
      width: 40px;
      height: 40px;
    }
    
    & .section-desktop {
      display: none;
      ${theme.breakpoints.up('md')} {
        display: flex;
      }
    }
    
    & .section-mobile {
      display: flex;
      ${theme.breakpoints.up('md')} {
        display: none;
      }
    }
  `}
`;

export const MenuList = styled.div`
  & .menu-item {
    padding: 0;
  }
`;
